"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrganizationStrings = exports.EnterpriseStrings = exports.WorkspaceStrings = void 0;
exports.workspaceStringWithPlaceholders = workspaceStringWithPlaceholders;
exports.combinedWorkspaceHandle = combinedWorkspaceHandle;
exports.combinedWorkspaceDisplayName = combinedWorkspaceDisplayName;
exports.WorkspaceStrings = {
    listTitle: "Workspaces",
    action: {
        add: "Add",
        removeMembers: "Remove from {group_type_ucfirst}",
    },
    label: {
        add: "Add People",
        addMembers: "Add members",
    },
    placeholder: {
        add: "Enter user names",
    },
    title: {
        add: "Add to {group_type_ucfirst}",
        removeMember: "Remove from {group_type_ucfirst}?",
    },
    confirmPrompt: {
        removeMember: "Are you sure you want to remove {user_handle} from {organization_display_name}?",
    },
};
exports.EnterpriseStrings = {
    listTitle: "Enterprises",
};
exports.OrganizationStrings = {
    listTitle: "Organizations",
    createDialogTitle: "Create an Organization",
    createDialogAction: "Create Org",
    label: {
        handle: "Org Account Name",
        displayName: "Org Display Name",
    },
    helper: {
        handle: "This name will be used for your URL.",
        displayName: "This name will display on your profile.",
    },
    error: {
        handle: {
            unavailable: "That account name has already been taken, choose another",
            required: "You must enter a name for your organization",
            minLength: "Must be at least 3 characters",
            maxLength: "Must be at most 128 characters",
            invalid: "Must only contain letters, numbers, and dashes",
        },
        displayName: {
            required: "You must enter a display name for your organization",
            minLength: "Must be at least 3 characters",
            maxLength: "Must be at most 255 characters",
            // can contain any utf-8 characters
        },
    },
};
/**
 * Replaces the following placeholders:
 *
 * - {group_type_ucfirst}: replaced with "Organization" if no enterprise given, with "Enterprise" if the organization is
 *     the default for the given enterprise, and "Enterprise Organization" otherwise
 * - {group_type}: replaced with "organization" if no enterprise given, with "enterprise" if the organization is the
 *     default for the given enterprise, and "enterprise_organization" otherwise
 */
function workspaceStringWithPlaceholders(organization, enterprise, stringWithPlaceholders) {
    const groupType = enterprise
        ? enterprise.defaultOrganizationUid === organization.uid
            ? "enterprise"
            : "enterprise organization"
        : "organization";
    const groupTypeUcFirst = enterprise
        ? enterprise.defaultOrganizationUid === organization.uid
            ? "Enterprise"
            : "Enterprise Organization"
        : "Organization";
    return stringWithPlaceholders.replace("{group_type_ucfirst}", groupTypeUcFirst).replace("{group_type}", groupType);
}
function combinedWorkspaceHandle(organizationMember) {
    if (!organizationMember.enterprise) {
        return organizationMember.organization.handle;
    }
    if (organizationMember.organization.uid === organizationMember.enterprise.defaultOrganizationUid) {
        return organizationMember.enterprise.handle;
    }
    return `${organizationMember.enterprise.handle}/${organizationMember.organization.handle}`;
}
function combinedWorkspaceDisplayName(organizationMember) {
    if (!organizationMember.enterprise) {
        return organizationMember.organization.displayName;
    }
    if (organizationMember.organization.uid === organizationMember.enterprise.defaultOrganizationUid) {
        return organizationMember.enterprise.displayName;
    }
    return `${organizationMember.enterprise.displayName} - ${organizationMember.organization.displayName}`;
}
//# sourceMappingURL=strings.js.map